import {h, Fragment} from "preact"
import { useFacet, useAppState } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import Checkbox from "./elements/Checkbox";
import Icon from "./elements/Icon";

export default function Facet({ facet, opened, setOpened }) {
  const { selectedFiltersCount, toggleActive, toggleProductFilter } =
    useFacet(facet);
  const { loading, query, response, pageType } = useAppState();
  const [active, setActive] = useState(false);
  const isCategory = pageType == "category";
  let isMobile = window.innerWidth < 769;
  const colourFacet = facet.name === "Colour";

  useEffect(() => {
    if (isMobile) {
      setActive(false);
    }
    if (isCategory) {
      setActive(false);
    }
  }, []);

  function handleClick(e) {
    if (
      e.target.closest(".ns-cat-sidebar-wrapper") &&
      window.innerWidth > 480
    ) {
      setActive(!active);
      setOpened(active ? null : facet.field);
    } else {
      setActive(!active);
    }
  }

  if (window.innerWidth > 480) {
    useEffect(() => {
      setActive(opened === facet.field);
    }, [opened, facet.field]);
  }

  // console.log(opened)

  return (
    <li
      class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}
      facet={facet.name}
    >
          <a
            class="ns-sidebar-title-box ns-filter-block-title ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated"
            href="javascript:void(0)"
            data-nosto-element="facet"
            onClick={(e) => {
              handleClick(e);
            }}
          >
            <span class="ns-sidebar-title ns-cat-title">
              {facet.name}
              {selectedFiltersCount > 0 && (
                <span class="ns-sidebar-count">({selectedFiltersCount})</span>
              )}
            </span>
            <i class="ns-icon ns-icon-arrow ns-absolute"></i>
          </a>
          {colourFacet ? (
            <div class="ns-sidebar-submenu ns-d-none">
              <ul class="ns-sidebar-submenu-list ns-list-unstyled">
                {facet.data?.map((value) => (
                  <li
                    class="ns-sidebar-submenu-item"
                    data-nosto-element="facet-setting"
                  >
                    <div class="ns-colour-circle-container">
                      <label class={`ns-checkbox ns-d-flex ${value.selected ? 'ns-checkbox-selected' : ''}`}>
                        <span
                          class={`ns-colour-circle circle-${value.value.trim()}`}
                          style={`background-image: url("//www.trotters.co.uk/cdn/shop/files/colour-${value.value.replace(
                            /\s/g,
                            ""
                          )}.png")`}
                        ></span>
                        <div class="ns-justify-content-between ns-d-flex ns-checkbox">
                          <span>{value.value}</span> <span>{value.count}</span>
                        </div>
                        <input
                          type="checkbox"
                          checked={value.selected}
                          onChange={(e) => {
                            e.preventDefault();
                            toggleProductFilter(
                              facet.field,
                              value.value,
                              !value.selected
                            );
                          }}
                        />
                        <span className="ns-checkmark" />
                      </label>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div class="ns-sidebar-submenu ns-d-none">
              <ul class="ns-sidebar-submenu-list ns-list-unstyled">
                {facet.data?.map((value) => (
                  <li
                    class="ns-sidebar-submenu-item"
                    data-nosto-element="facet-setting"
                  >
                    <Checkbox
                      value={value.value}
                      selected={value.selected}
                      count={value.count}
                      onChange={(e) => {
                        e.preventDefault();
                        toggleProductFilter(
                          facet.field,
                          value.value,
                          !value.selected
                        );
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
          )}
    </li>
  );
}
